import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faRotate,
    faCircleArrowLeft,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";

const ContractTypeFrom = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [code, setCode] = useState("");
    const [description, setDescription] = useState("");
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [flagActive, setCheckObservacion] = useState(false);
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchContractType = async () => {
                try {
                    const response = await apiClient.get(`/contract_type/${id}`);
                    setCode(response.data.code);
                    setDescription(response.data.description);
                    setCheckObservacion(response.data.flagActive === 1 ? true : false || false);
                } catch (error) {
                    console.error("Error al cargar el tipo de contrato", error);
                }
            };
            fetchContractType();
        }
    }, [id]);

    const toggleSwitch = () => {
        setCheckObservacion((prev) => !prev);
    };
    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };

    const validateFields = () => {
        let validationErrors = {};
        if (!code) validationErrors.code = "El Campo es Obligatorio";
        if (!description) validationErrors.description = "El Campo es Obligatorio";
        return validationErrors;
    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            let response;
            if (id) {
                const payloadUpdate = {
                    description,
                    flagActive
                };
                response = await apiClient.patch(`/contract_type/${id}`, payloadUpdate);
                if (response.status === 200) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setIsLoginVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/ContractTypeList");
                }
            } else {
                const payload = {
                    code,
                    description,
                    flagActive
                };
                response = await apiClient.post("/contract_type", payload);
                if (response.status === 201) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/ContractTypeList");
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("CONTRACT_TYPE_ALREADY_EXIST")) {
                setMessageBlock("El Tipo de Contrato ya existe.");
                setNotificationBlock(true);
            }
            else {
                setErrorMessage("¡Oops! Ocurrio un error al crear el Tipo de Contrato");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Tipos de Contrato" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ContractTypeList");
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Tipo de Contrato</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.code ? "red" : "revert-layer" }}>
                            CÓDIGO
                        </label>
                        <input
                            type="text"
                            placeholder="Código"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            readOnly={!!id}
                        />
                        {errors.code && <p className="error-message">{errors.code}</p>}
                    </div>

                    <div className="basic-info-form-group">
                        <label style={{ color: errors.description ? "red" : "revert-layer" }}>
                            Descripción
                        </label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                        {errors.description && <p className="error-message">{errors.description}</p>}
                    </div>

                    <div className="basic-info-form-group">
                        <div className="basic-info-form-switch">
                            <label>Estado</label>
                            <div className="slider-container-contract" onClick={toggleSwitch}>
                                <div className={`slider-option-contract ${flagActive
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Activo
                                </div>
                                <div className={`slider-option-contract ${!flagActive
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Inactivo
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ContractTypeList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    id
                        ? "El Tipo de Contrato se ha Actualizado Correctamente."
                        : "El Tipo de Contrato se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuelve a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Tipo de Contrato debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={"/ContractTypeList"}
                    whatsApp={false}
                />
            )}

        </div>
    );
};

export default ContractTypeFrom;
